<template>
  <div class="ipeds-picker">
    <div
      v-show="inputShown"
      class="hint"
      style="text-align: left; margin-bottom: 0.5rem; font-weight: bold;"
    >
      IPEDS Institution
    </div>

    <div
      class="autocomplete-wrapper"
      style="text-align: left;"
    >
      <PickerInput
        ref="suggestInput"
        :picker-id="inputId + '_picker'"
        :aria-describedby="inputId + '_picker-ipeds-help ' + inputId + '_picker-ipeds-details'"
        :aria-activedescendant="descendantAsign(highlightedIndex, inputId, '_picker-option-')"
        :aria-controls="showSuggestions ? inputId + '_picker-suggestions' : null"
        aria-label="IPEDS Institution search"
        type="text"
      />

      <SuggestionsDropdown
        :picker-id="inputId"
        :show-suggestions="showSuggestions"
        :suggestions="suggestions"
        :highlighted-index="highlightedIndex"
        :dropdown-style="dropdownStyle"
        dropdowntype="ipeds"
        suggestion-suffix="_picker-suggestions"
        option-suffix="_picker-option-"
        @select-suggestion="selectSuggestion"
        @update-highlighted="highlightedIndex = $event"
      />

      <LoadingIndicator :loading="loading" />
    </div>

    <div
      v-show="inputShown"
      :id="inputId + '_picker-ipeds-help'"
      class="hint"
      style="text-align: left; margin-top: 0.25rem; font-size: 0.875rem;"
    >
      Enter a keyword or IPEDS Unit ID for the institution.
    </div>

    <div
      v-if="shownLabel || shownDescription"
      :id="inputId + '_picker-ipeds-details'"
      class="vue-simple-picker__description"
    >
      <span
        v-if="shownLabel"
        class="vue-simple-picker__short-label"
      >
        {{ chosen?.shortLabel || chosen?.label }}
      </span>
      <span
        v-if="shownDescription"
        class="vue-simple-picker__code"
      >
        {{ chosen?.code }}
      </span>
      <span
        v-if="shownDescription"
        class="vue-simple-picker__label-description"
      >
        {{ chosen?.description }}
      </span>
    </div>

    <input
      :id="inputId"
      :value="fieldValue"
      :name="inputName"
      type="hidden"
    />
  </div>
</template>

<script>
import './vue_picker.css';
import BasePicker from './onet_naics_shared';
import LoadingIndicator from './LoadingIndicator.vue';
import SuggestionsDropdown from './SuggestionsDropdown.vue';
import PickerInput from './PickerInput.vue';

export default {
  name: 'IpedsPicker',

  components: {
    LoadingIndicator,
    PickerInput,
    SuggestionsDropdown,
  },

  extends: BasePicker,

  methods: {
    apiUrl() {
      return '/lookup/ipeds_lookups.json';
    },

    async fetchSuggestions() {
      try {
        const results = await this.populateLookupData();

        this.suggestions = results.slice(0, 25); // Max 25
        this.showSuggestions = true;
        this.highlightedIndex = -1;
        this.takeLocation();
      } catch (_error) {
        this.suggestions = [];
        this.showSuggestions = false;
      }
    },
  },
};
</script>
